import React, {useState} from 'react'
import {getDetailById} from "../../services/serviceProduction";
import {Button} from "antd";
import ProductionUpdateModal from "./ProductionUpdateModal";


const ProductionUpdate = ({productionItem, updater}) => {
    const [production, setProduction] = useState()
    const [updateModal, setUpdateModal] = useState(false)
    const handleEditClick = () => {
        getDetailById(productionItem.id)
            .then(({data}) => {
                setProduction(data)
                setUpdateModal(!updateModal)
            })
    }
    const modalCloser = () => {
        setUpdateModal(!updateModal)
        updater()
    }

    return(
        <React.Fragment>
            <Button
                type={'link'}
                onClick={handleEditClick}
            >
                Güncelle
            </Button>

            { updateModal ? <ProductionUpdateModal show={updateModal} record={production} modalCloser={modalCloser}/> : null }
        </React.Fragment>
    )
}
export default ProductionUpdate